const type = 'SET_CALL_HISTORY_LOADING_MORE';

const setCallHistoryLoadingMore = (data) => ({
  data,
  type,
});

export { type };
export default setCallHistoryLoadingMore;
